import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash/orderBy';
import DraggableWidgetItem from './DraggableWidgetItem';

export default function LibraryWidgetsView(props) {
    const className = props.isCurrentView
        ? 'widget-library__widgets-view'
        : 'widget-library__widgets-view widget-library__widgets-view--closed';

    const widgetsToShow = props.availableWidgets.filter(
        (widget) =>
            widget.dashboardKey === props.selectedDashboardView.dashboardKey &&
            widget.viewKey === props.selectedDashboardView.viewKey
    );

    return (
        <div className={className}>
            {orderBy(widgetsToShow, [
                'stateData.title',
                'panelTitle',
                'tabTitle',
            ]).map((widget) => (
                <DraggableWidgetItem
                    key={widget.key} // eslint-disable-line react/no-array-index-key
                    gridLayout={props.gridLayout}
                    incorrectlyConfiguredDashboards={
                        props.incorrectlyConfiguredDashboards
                    }
                    onAdd={props.onAdd}
                    setDraggingWidget={props.setDraggingWidget}
                    widget={widget}
                />
            ))}
        </div>
    );
}

LibraryWidgetsView.propTypes = {
    availableWidgets: PropTypes.instanceOf(Array).isRequired,
    gridLayout: PropTypes.instanceOf(Array).isRequired,
    incorrectlyConfiguredDashboards: PropTypes.instanceOf(Object).isRequired,
    isCurrentView: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    selectedDashboardView: PropTypes.instanceOf(Object).isRequired,
    setDraggingWidget: PropTypes.func.isRequired,
};
